/**
 * Logger léger — n'affiche les logs qu'en dev pour ne pas exposer les détails internes en prod.
 *
 * Usage : `import logger from '../lib/logger';`
 *   logger.error('Auth check failed:', err);
 *   logger.warn('something');
 *   logger.info('something');
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  // Les erreurs sont toujours affichées : elles aident à diagnostiquer les pannes.
  error: (...args) => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
  warn: isDev
    ? (...args) => {
        // eslint-disable-next-line no-console
        console.warn(...args);
      }
    : noop,
  info: isDev
    ? (...args) => {
        // eslint-disable-next-line no-console
        console.info(...args);
      }
    : noop,
  log: isDev
    ? (...args) => {
        // eslint-disable-next-line no-console
        console.log(...args);
      }
    : noop,
  debug: isDev
    ? (...args) => {
        // eslint-disable-next-line no-console
        console.debug(...args);
      }
    : noop,
};

export default logger;
